<template>
  <v-row justify="center">
    <v-dialog :value="confirmCommentOpen" persistent max-width="540">
      <v-card :color="color" dark>
        <v-card-title class="headline white--text">{{ title }}</v-card-title>
        <v-text-field v-model="comment" outlined dense label="Comment">
        </v-text-field>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="orange" @click="onClose">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="onConfirm" :disabled="!comment"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["title", "confirmCommentOpen", "color"],
  name: "ConfirmModal",
  data() {
    return {
      comment: "",
    };
  },
  methods: {
    onClose() {
      this.$emit("cancelCommentConfirm");
    },
    onConfirm() {
      this.$emit("confirmComment", this.comment);
    },
  },
};
</script>
